var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:"backRef",staticClass:"chart",staticStyle:{"padding-top":"30px"},attrs:{"options":_vm.chartOptions,"constructor-type":'chart'}})}
var staticRenderFns = []

export { render, staticRenderFns }